import React from 'react';
import { Calendar, FileText, AlertCircle } from 'lucide-react';

const EventSection = ({ 
  data, 
  errors, 
  onChange 
}) => {
  return (
    <div className="bg-green-50 rounded-lg shadow-sm border border-green-200 p-6">
      <div className="flex items-center space-x-2 mb-6">
        <Calendar className="w-5 h-5 text-green-600" />
        <h3 className="text-lg font-semibold text-green-900">Evento Inicial</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Fecha del Estado */}
        <div className="space-y-2">
          <label className="block text-sm font-medium text-green-900">
            Fecha del Estado
          </label>
          <input
            type="date"
            value={data.status_date.split('T')[0]} 
            onChange={(e) => onChange('status_date', new Date(e.target.value).toISOString())}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
          />
        </div>

        {/* Espacio para mantener el diseño */}
        <div></div>

        {/* Detalle del Estado - Ocupa toda la fila */}
        <div className="space-y-2 md:col-span-2">
          <label className="block text-sm font-medium text-green-900">
            Detalle del Estado Inicial *
          </label>
          <textarea
            value={data.status_detail}
            onChange={(e) => onChange('status_detail', e.target.value)}
            rows={4}
            className={`w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 ${
              errors.initialEvent ? 'border-red-500' : 'border-gray-300'
            }`}
            placeholder="Describe el estado inicial del envío (ej: Carga recibida en bodega, En proceso de documentación, etc.)"
          />
          {errors.initialEvent && (
            <p className="text-red-600 text-sm">{errors.initialEvent}</p>
          )}
        </div>
      </div>

      {/* Información importante */}
      <div className="mt-6 p-4 bg-amber-50 border border-amber-200 rounded-lg">
        <div className="flex items-start space-x-3">
          <AlertCircle className="w-5 h-5 text-amber-600 mt-0.5" />
          <div className="flex-1">
            <h4 className="text-sm font-medium text-amber-800 mb-1">
              Importante sobre el evento inicial
            </h4>
            <div className="text-sm text-amber-700 space-y-1">
              <p>
                • Este será el primer evento registrado para el envío
              </p>
              <p>
                • El evento se marcará como <strong>aprobado automáticamente</strong> al crear el envío
              </p>
              <p>
                • Se enviará una notificación por email a los destinatarios seleccionados
              </p>
              <p>
                • Puedes agregar más eventos posteriormente desde "Actualizar Estados"
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventSection;